import React from 'react';
import { Link, NavLink, Redirect } from 'react-router-dom';
import 'semantic-ui-css/components/accordion.min.css';
import 'semantic-ui-css/components/button.min.css';
import 'semantic-ui-css/components/container.min.css';
import 'semantic-ui-css/components/dimmer.min.css';
import 'semantic-ui-css/components/divider.min.css';
import 'semantic-ui-css/components/dropdown.min.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/grid.min.css';
import 'semantic-ui-css/components/header.min.css';
import 'semantic-ui-css/components/input.min.css';
import 'semantic-ui-css/components/item.min.css';
import 'semantic-ui-css/components/list.min.css';
import 'semantic-ui-css/components/loader.min.css';
import 'semantic-ui-css/components/menu.min.css';
import 'semantic-ui-css/components/placeholder.min.css';
import 'semantic-ui-css/components/search.min.css';
import 'semantic-ui-css/components/sidebar.min.css';
import 'semantic-ui-css/components/transition.min.css';
import { Button, Menu, Sidebar } from 'semantic-ui-react';
import './admin.layout.scss';

import 'semantic-ui-css/components/embed.min.css';
import 'semantic-ui-css/components/message.min.css';
import 'semantic-ui-css/components/nag.min.css';

const ADMIN_THEME_STORAGE_KEY = 'chef-admin-theme';

type AdminThemePreference = 'light' | 'dark';

function readStoredThemePreference(): AdminThemePreference {
    try {
        const raw = localStorage.getItem(ADMIN_THEME_STORAGE_KEY);
        if (raw === 'light' || raw === 'dark') {
            return raw;
        }
    } catch {
        /* ignore */
    }
    return 'light';
}

// import 'semantic-ui-css/semantic.min.css';

interface LayoutProps {
    children: any
}
interface LayoutState {
    sidebarOpen: boolean;
    activeMenuItem: string
    redirect: string
    themePreference: AdminThemePreference
}

interface MenuEntry {
    name: string
    url: string
    children?: { name: string, addUrl: string }[]
}

class AdminLayout extends React.Component<LayoutProps, LayoutState> {

    activeMenuItem = "";

    basicMenuItems = [
        { name: "Жагсаалт", addUrl: "" },
        { name: "Шинэ", addUrl: "new" }
    ];

    public menuList: MenuEntry[] = [
        { name: 'Бүтээгдэхүүн', url: '/mongol/products', children: this.basicMenuItems },
        { name: 'Бараа буцаах', url: '/mongol/return' },
        { name: 'Миний буцаалт', url: '/mongol/return/history' },
        { name: 'Нийлүүлэгч', url: '/mongol/providers', children: this.basicMenuItems },
        { name: 'Нийлүүлэгч ажилтан', url: '/mongol/provider-users' },
        { name: 'Брэнд', url: '/mongol/brands', children: this.basicMenuItems },
        { name: 'Категори', url: '/mongol/categories', children: this.basicMenuItems },
        { name: 'Хэрэглэгч', url: '/mongol/clients' },
        { name: 'Байгууллага', url: '/mongol/companies', children: this.basicMenuItems },
        { name: 'Баннер', url: '/mongol/banners', children: this.basicMenuItems },
        { name: 'Онцлох Контент', url: '/mongol/contents', children: this.basicMenuItems },
        { name: 'Хүргэлтгүй өдрүүд', url: '/mongol/dayoff' },
        { name: 'Хүргэлтийн бүс', url: '/mongol/delivery-zones' },
        { name: 'Веб сайтын тохиргоо', url: '/mongol/settings' },
    ]

    constructor(props: any) {
        super(props);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.state = {
            sidebarOpen: true,
            activeMenuItem: this.menuList[0].name,
            redirect: "",
            themePreference: readStoredThemePreference(),
        };
    }

    setThemePreference = (themePreference: AdminThemePreference) => {
        try {
            localStorage.setItem(ADMIN_THEME_STORAGE_KEY, themePreference);
        } catch {
            /* ignore */
        }
        this.setState({ themePreference });
    };

    componentDidMount() {
        this.setState({ sidebarOpen: false, activeMenuItem: this.menuList[0].name });
    }

    toggleSidebar = () => {
        this.setState({ sidebarOpen: !this.state.sidebarOpen })
    }

    hideSidebar = () => {
        this.setState({ sidebarOpen: false })
    }

    handleMenuItemClick(name: string) {
        this.setState({ activeMenuItem: name });
    }

    logout() {
        localStorage.removeItem('adminToken')
        this.setState({ redirect: "/mongol-login" })
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        const { themePreference } = this.state;
        const themeClass = `admin-theme-${themePreference}`;

        return (
            <div className={`admin-layout ${themeClass}`}>
                <div className="upper-container">
                    <div className="upper-section">

                        <div className="left section">
                            <div className="burger-menu" onClick={() => this.toggleSidebar()}>
                                <span className="icon icon-menu"></span>
                            </div>
                            <div className="left-content">
                            </div>
                        </div>

                        <div className="right section">
                            <Menu size='tiny'>
                                <Link to="/mongol">
                                    <Menu.Item name='Нүүр'/>
                                </Link>
                                {/* <Menu.Item
                                    name='Мессеж'
                                    // onClick={this.handleItemClick}
                                /> */}

                                <Menu.Menu position='right' size='tiny'>
                                    <Menu.Item className="admin-theme-toggle">
                                        <Button
                                            type="button"
                                            size="small"
                                            icon={themePreference === 'light' ? 'moon' : 'sun'}
                                            title={themePreference === 'light' ? 'Харанхуй горим' : 'Гэрэл горим'}
                                            onClick={() =>
                                                this.setThemePreference(
                                                    themePreference === 'light' ? 'dark' : 'light',
                                                )
                                            }
                                        />
                                    </Menu.Item>

                                    <Menu.Item>
                                        <Button primary onClick={() => this.logout()}>Системээс гарах</Button>
                                    </Menu.Item>
                                </Menu.Menu>
                            </Menu>
                        </div>

                    </div>
                </div>

                <Sidebar.Pushable>
                    <Sidebar
                        as={Menu}
                        animation='push'
                        icon='labeled'
                        vertical
                        visible={this.state.sidebarOpen}
                    >
                        <Menu.Item>
                            <Menu.Header>Тайлан</Menu.Header>
                            <Menu.Menu>
                                <Link to="/mongol/report/orders">
                                    <Menu.Item name="Захиалгууд"></Menu.Item>
                                </Link>
                                <Link to="/mongol/report/delivery">
                                    <Menu.Item name="Хүргэлт"></Menu.Item>
                                </Link>
                                <Link to="/mongol/report/papa-deliveries">
                                    <Menu.Item name="Papa хүргэлт"></Menu.Item>
                                </Link>
                                <Link to="/mongol/report/payments">
                                    <Menu.Item name="Орлого"></Menu.Item>
                                </Link>
                                <Link to="/mongol/report/ordersbi">
                                    <Menu.Item name="Захиалгын тайлан"></Menu.Item>
                                </Link>
                            </Menu.Menu>
                        </Menu.Item>
                        {this.menuList.map((menuItem) => {
                            return menuItem.children ?
                                <Menu.Item key={"menu-sub-item-" + menuItem.name}>
                                    <Menu.Header>{menuItem.name}</Menu.Header>
                                    <Menu.Menu>
                                        {
                                            menuItem.children.map((subItem: any) => {
                                                return <Menu.Item key={"menu-sub-item-" + subItem.name}
                                                    as={NavLink}
                                                    link={true}
                                                    to={menuItem.url + "/" + subItem.addUrl}
                                                    name={subItem.name}
                                                    active={this.state?.activeMenuItem === menuItem.name + "-" + subItem.name}
                                                    onClick={() => this.handleMenuItemClick(menuItem.name + "-" + subItem.name)}
                                                />
                                            })
                                        }
                                    </Menu.Menu>
                                </Menu.Item>
                                :
                                <Menu.Item key={"menu-sub-item-" + menuItem.name}
                                    as={NavLink}
                                    link={true}
                                    to={menuItem.url}
                                    name={menuItem.name}
                                    active={this.state?.activeMenuItem === menuItem.name + "-" + menuItem.name}
                                    onClick={() => this.handleMenuItemClick(menuItem.name + "-" + menuItem.name)}
                                />
                        })
                        }
                    </Sidebar>

                    <Sidebar.Pusher onClick={() => this.hideSidebar()} className="admin-layout-content">
                        {this.props.children}
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
                {/*
                  Modal portal must stay outside Sidebar.Pushable: Semantic UI sets transform on .pushable,
                  which makes position:fixed modals position relative to that subtree (wrong when scrolled).
                  Still under .admin-layout for --admin-* variables; see .admin-modal-mount in admin.layout.scss.
                */}
                <div id="admin-modal-mount" className="admin-modal-mount" />
            </div>
        );
    }
}

export default AdminLayout;